import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
// import Fade from '@material-ui/core/Fade'
import Wrapper from '../wrapper'
import { ButtonOutlined } from '../app-button/button'
import { withSnackbar } from 'notistack'
// import Collapse from '@material-ui/core/Collapse'
import Slide from '@material-ui/core/Slide'

const styles = theme => ({
  paymentBox: {
    position: 'absolute',
    top: 0,
    left: 0,
    maxWidth: 380,
    width: '100%',
    height: '100%',
    marginLeft: 0,
    padding: '16px 32px',
    borderRadius: 8,
    zIndex: 100,
  },
  paymentTitle: {
    marginBottom: 24,
    fontFamily: 'Roboto',
    fontSize: 8,
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 2,
    letterSpacing: 2,
    color: 'rgba(0, 0, 0, 0.5)',
    textTransform: 'uppercase',
  },
  confirmCard: {
    '& header': {
      marginBottom: 16,
    },
    '& p': {
      marginTop: 0,
      marginBottom: 16,
    },
  },
  confirmBtns: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 32,
  },
  cancelBtn: {
    width: 140,
    height: 40,
    padding: 0,
    fontSize: 16,
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000000',
    border: 'solid 1px #bbbbbb',
  },
  doneBtn: {
    width: 160,
    height: 40,
    marginLeft: 16,
    padding: 0,
    fontSize: 16,
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000000',
    border: 'solid 2px #ff4e44',
    '&:hover': {
      border: 'solid 2px #ff4e44',
    },
  },
})

class ConfirmActions extends Component {
  state = {
    open: this.props.statusCard,
    cardDeleteUrl: window.state.card && window.state.card.deleteUrl,
    cardEditUrl: window.state.card && window.state.card.editUrl,
    editCard: this.props.editCard,
  }

  handleCancel = () => {
    this.setState(
      {
        open: false,
        // editCard: false,
      },
      () => {
        this.props.response.getStatusCard(this.state.open, this.state.editCard)
      }
    )
  }

  handleDone = () => {
    this.setState({
      load: true,
    })
    const url = `${this.state.cardDeleteUrl}`

    const options = () => ({
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
    })

    const handleServerError = message => {
      this.setState({
        isFetching: false,
      })

      if (message.errors && message.status == 422) {
        this.setState({
          errors: message.errors,
        })
      } else {
        const error = `Произошла ошибка на сервере (${message.status}).
        Попробуйте снова или обратитесь в поддержку.`

        this.props.enqueueSnackbar(error, {
          variant: 'error',
          preventDuplicate: true,
          autoHideDuration: 6000,
        })
      }
    }

    function handleResponse(response) {
      return response.json().then(json => {
        if (response.ok) {
          return json
        } else {
          let error = Object.assign({}, json, {
            status: response.status,
            statusText: response.statusText,
          })

          return Promise.reject(error)
        }
      })
    }

    // Отправка события отвязки карты
    // window.dataLayer.push({'event': 'carduntied'})

    fetch(url, options())
      .then(handleResponse)
      .then(({ status }) => {
        if (status === 'ok') {
          this.setState(
            {
              open: false,
            },
            () => {
              this.props.response.deleteCard()
            }
          )
        }
      })
      .catch(message => handleServerError(message))
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.statusCard !== this.props.statusCard) {
      this.setState({
        open: this.props.statusCard,
      })
    }
    if (prevProps.editCard !== this.props.editCard) {
      this.setState({
        editCard: this.props.editCard,
      })
    }
  }

  render() {
    const { classes } = this.props
    const { open, editCard } = this.state
    const { expirationDate } = this.props.license

    const untieCard = (
      <div className={classes.confirmCard}>
        <header>
          <strong>
            {editCard
              ? `Вы хотите изменить карту?`
              : `Вы хотите отвязать карту?`}
          </strong>
        </header>
        <p>Ваша лицензия на ROMI center действительна до {expirationDate}.</p>
        <p>
          Если вы не добавите карту до этого времени – передача данных для
          вашего аккаунта будет прекращена.
        </p>
        <div className={classes.confirmBtns}>
          <ButtonOutlined
            handleClick={this.handleCancel}
            className={classes.cancelBtn}
            color="secondary"
            text={'Отмена'}
          />
          {!editCard ? (
            <ButtonOutlined
              handleClick={this.handleDone}
              className={classes.doneBtn}
              text={'Отвязать карту'}
            />
          ) : (
            <ButtonOutlined
              className={classes.doneBtn}
              href={this.state.cardEditUrl}
              text={'Изменить карту'}
            />
          )}
        </div>
      </div>
    )
    return (
      <Slide
        direction="down"
        in={open}
        {...(open ? { timeout: 400 } : { timeout: 400 })}
        mountOnEnter
        unmountOnExit
      >
        <Wrapper shadow={1} className={classes.paymentBox}>
          <header className={classes.paymentTitle}>Платежи</header>
          {untieCard}
        </Wrapper>
      </Slide>
    )
  }
}

export default withStyles(styles)(withSnackbar(ConfirmActions))
